import { render } from "./ShowCampoInfo.vue?vue&type=template&id=9423fff8&scoped=true"
import script from "./ShowCampoInfo.vue?vue&type=script&lang=js"
export * from "./ShowCampoInfo.vue?vue&type=script&lang=js"

import "./ShowCampoInfo.vue?vue&type=style&index=0&id=9423fff8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9423fff8"]])

export default __exports__